/**
 * @file: useWithdraw.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import type { SettingsNavParams } from '@euler/app/flows/settings/screens';
import { useAppLoading } from '@euler/components/loading/Provider';
import { useServiceFactory } from '@euler/services/factory';
import { safeMarkDevFlag } from '@euler/utils';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';

const kForceReAuth = safeMarkDevFlag(false);

export const useWithdraw = () => {
  const navigation = useNavigation<StackNavigationProp<SettingsNavParams>>();
  const loading = useAppLoading();
  const { userService } = useServiceFactory();

  const onWithdraw = useCallback(async () => {
    loading.show();
    try {
      const binding = await userService.getWeixinLoginBindInfo();
      if (binding?.nick == null || kForceReAuth) {
        navigation.push('_withdrawWeixinAuth', {});
        return;
      }
      navigation.push('_withdraw', {
        binding,
      });
    } catch (e) {
      alert((e as any).message);
    } finally {
      loading.hide();
    }
  }, [loading, navigation, userService]);

  return { onWithdraw };
};
